var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3885_13278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5801 34.58L36.0001 32V22C36.0001 15.86 32.7201 10.72 27.0001 9.36V8C27.0001 6.34 25.6601 5 24.0001 5C22.3401 5 21.0001 6.34 21.0001 8V9.36C15.2601 10.72 12.0001 15.84 12.0001 22V32L9.4201 34.58C8.1601 35.84 9.0401 38 10.8201 38H37.1601C38.9601 38 39.8401 35.84 38.5801 34.58ZM32.0001 34H16.0001V22C16.0001 17.04 19.0201 13 24.0001 13C28.9801 13 32.0001 17.04 32.0001 22V34ZM24.0001 44C26.2001 44 28.0001 42.2 28.0001 40H20.0001C20.0001 42.2 21.7801 44 24.0001 44Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3885_13278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.6464327ec502761c383b35f8e0481b19.svg";
export { ForwardRef as ReactComponent };